import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "etb_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data;
};
export const adminMe = async () => (await axios.get(`${API}/auth/me`, authHeader())).data;
export const adminLeads = async () => (await axios.get(`${API}/admin/leads`, authHeader())).data;
export const adminStats = async () => (await axios.get(`${API}/admin/stats`, authHeader())).data;

export const adminGetSettings = async () => (await axios.get(`${API}/admin/settings`, authHeader())).data;
export const adminUpdateSettings = async (notify_email) => (await axios.put(`${API}/admin/settings`, { notify_email }, authHeader())).data;
export const adminEmailLogs = async () => (await axios.get(`${API}/admin/email-logs`, authHeader())).data;
export const adminTestNotification = async () => (await axios.post(`${API}/admin/test-notification`, {}, authHeader())).data;
export const adminDeleteLead = async (id) => (await axios.delete(`${API}/admin/leads/${id}`, authHeader())).data;

export const adminBillFile = async (id) => {
  const res = await axios.get(`${API}/admin/bill/${id}/file`, { ...authHeader(), responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  window.open(url, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const adminBillDownload = async (id) => {
  const res = await axios.get(`${API}/admin/bill/${id}/file`, {
    ...authHeader(),
    params: { download: true },
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `rechnung-${id}`;
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const adminScrape = async (params) => (await axios.post(`${API}/admin/scrape`, params, authHeader())).data;
export const adminScrapedLeads = async () => (await axios.get(`${API}/admin/scraped-leads`, authHeader())).data;
export const adminUpdateScrapedLead = async (id, updates) => (await axios.patch(`${API}/admin/scraped-leads/${id}`, updates, authHeader())).data;
export const adminDeleteScrapedLead = async (id) => (await axios.delete(`${API}/admin/scraped-leads/${id}`, authHeader())).data;
export const adminExportScrapedLeads = async () => {
  const res = await axios.get(`${API}/admin/scraped-leads/export`, { ...authHeader(), responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "leads-export.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const createLead = async (payload) => {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
};

export const sendChat = async ({ session_id, message, history }) => {
  const { data } = await axios.post(`${API}/chat`, { session_id, message, history });
  return data;
};

export const analyzeBill = async ({ file, name, email, phone }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("name", name);
  form.append("email", email);
  form.append("phone", phone || "");
  const { data } = await axios.post(`${API}/bill/analyze`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
